var _path, _path2, _path3, _path4, _path5, _path6, _filter;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFont = function SvgFont(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.08,
    d: "M27 96.667V31.333C27 19.083 31.111 15 43.444 15h24.667L101 47.667v49C101 108.917 96.889 113 84.555 113h-41.11C31.11 113 27 108.917 27 96.667",
    style: {
      fill: "#000",
      fillOpacity: 0.08
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg_icon_Font__filter0_dd_2254_16604)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16",
    style: _defineProperty(_defineProperty({
      fill: "#fefefe"
    }, "fill", "color(display-p3 .9961 .9961 .9961)"), "fillOpacity", 1)
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Font__paint0_linear_2254_16604)",
    fillOpacity: 0.16,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Font__paint1_linear_2254_16604)",
    fillOpacity: 0.08,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Font__paint2_radial_2254_16604)",
    fillOpacity: 0.2,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Font__paint3_radial_2254_16604)",
    fillOpacity: 0.4,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Font__paint4_radial_2254_16604)",
    fillOpacity: 0.8,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_Font__clip0_2254_16604)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.48,
    d: "M65.667 89.333V91q0 .708-.48 1.188-.479.479-1.187.479t-1.187-.48-.48-1.187v-6.667q0-.708.48-1.187.479-.48 1.187-.48t1.188.48q.479.48.479 1.187V86h11.666q.709 0 1.188.48.48.479.479 1.187 0 .708-.48 1.187-.478.48-1.187.48zm-15 0q-.709 0-1.188-.479-.48-.48-.479-1.187 0-.708.48-1.188.478-.48 1.187-.479h6.666q.709 0 1.188.48.48.479.479 1.187 0 .708-.48 1.187-.478.48-1.187.48zM60 74.208h8.042l1.416 4.084q.167.458.584.75.416.291.916.291.833 0 1.334-.708.5-.708.166-1.5l-6.25-16.708a1.78 1.78 0 0 0-.625-.792 1.63 1.63 0 0 0-.958-.292h-1.25q-.541 0-.958.292a1.78 1.78 0 0 0-.625.792L55.5 77.167q-.291.791.188 1.479.478.687 1.312.687.542 0 .938-.291.395-.292.604-.792zm1-2.875 2.917-8.291h.166L67 71.333z",
    style: {
      fill: "#000",
      fillOpacity: 0.48
    }
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M68 16s23.054 23.074 32 32H84c-12 0-16-4-16-16z",
    style: _defineProperty(_defineProperty({
      fill: "#fefefe"
    }, "fill", "color(display-p3 .9948 .9948 .9948)"), "fillOpacity", 1)
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Font__paint5_linear_2254_16604)",
    fillOpacity: 0.12,
    d: "M68 16s23.054 23.074 32 32H84c-12 0-16-4-16-16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.08,
    d: "M68 16s23.054 23.074 32 32H84c-12 0-16-4-16-16z",
    style: {
      fill: "#fff",
      fillOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_Font__paint2_radial_2254_16604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 34 -29.1429 0 85.5 34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_Font__paint3_radial_2254_16604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.00012 20.49993 -23.02097 -10.10694 87.5 33.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_Font__paint4_radial_2254_16604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(135 38.494 32.933)scale(27.5772 18.3848)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_Font__paint0_linear_2254_16604",
    x1: 64,
    x2: 64,
    y1: 16,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_Font__paint1_linear_2254_16604",
    x1: 64,
    x2: 64,
    y1: 16,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_Font__paint5_linear_2254_16604",
    x1: 84,
    x2: 71.5,
    y1: 31,
    y2: 44.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_Font__clip0_2254_16604"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    },
    transform: "translate(44 56)"
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "svg_icon_Font__filter0_dd_2254_16604",
    width: 88,
    height: 112,
    x: 20,
    y: 16,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2254_16604"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2254_16604",
    result: "effect2_dropShadow_2254_16604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2254_16604",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFont);
export { ForwardRef as ReactComponent };